/**
 * FAQ PAGE
 *
 * @returns {Promise<void>}
 */
const main = async () => {
    const [
        {default: Vue},
        { BCollapse },
        { VBToggle }
     ] = await Promise.all([
        import(/* webpackChunkName: "vue" */ 'vue'),
        import(/* webpackChunkName: "bs-collapse" */ 'bootstrap-vue'),
        import(/* webpackChunkName: "bs-toggle" */ 'bootstrap-vue'),
    ]);

    Vue.directive('b-toggle', VBToggle);

    let elements = [];
    const main = document.getElementById('faq')
    if(main) {
        elements.push(main)
    }
    document.querySelectorAll('.faq').forEach(el => {
        elements.push(el)
    })

    // Create our vue instance
    return elements.map(el => {
        const vm = new Vue({
            name: 'FaqPageBody',
            el: el,
            delimiters: ['[[', ']]'],
            components: {
                'b-collapse': BCollapse,
            },
        });

        return vm
    });
};

// Execute async function
main().then( (vm) => {
});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
    module.hot.accept();
}
